/**
 * PreviewPage：弹窗内的“报告预览页”。
 *
 * 约束/注意点：
 * - 预览与卡片展示复用同一个 `AIAnalysisBox`，保证状态与渲染一致；
 * - Apply-and-Exit 只在已有 previewPromptInfo/previewRequestParams 后才允许（上层通过 applyDisabled 控制），
 *   避免用户在“未跑预览/无会话”时误接管到空 session。
 */
import React, { memo } from 'react';
import { Button } from 'tea-component';
import { useIntl } from 'umi';
import AIAnalysisBox from '../AIAnalysisBox';
import type { IAiAnalysisStreamingInput } from '../types';
import type { IUseStreamingConversationResult } from '@dbl/core/global';

export interface IPreviewPageProps {
  onBackToSettings: () => void;
  onApplyAndExit: () => Promise<void>;
  session: IUseStreamingConversationResult<IAiAnalysisStreamingInput>;
  onRunAnalysis: () => Promise<void>;
  applyDisabled?: boolean;
  hasAnalyzableCharts?: boolean;
}

const PreviewPage: React.FC<IPreviewPageProps> = (props) => {
  const {
    onBackToSettings,
    onApplyAndExit,
    session,
    onRunAnalysis,
    applyDisabled,
    hasAnalyzableCharts = true,
  } = props;
  const { formatMessage } = useIntl();

  return (
    <div className="dbl-ai-analysis-report-preview">
      <div className="dbl-ai-analysis-report-preview__content">
        <AIAnalysisBox
          session={session}
          hasAnalyzableCharts={hasAnalyzableCharts}
          onRunAnalysis={onRunAnalysis}
        />
      </div>
      <div className="dbl-ai-analysis-settings__actions">
        <Button type="primary" onClick={onApplyAndExit} disabled={applyDisabled}>
          {formatMessage({ id: 'dbl_ai_analysis_apply_and_exit' })}
        </Button>
        <Button onClick={onBackToSettings}>
          {formatMessage({ id: 'dbl_common_back' })}
        </Button>
      </div>
    </div>
  );
};

export default memo(PreviewPage);
